import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import { checkPermission } from "./validation";
const hasPermission = (user, account, workspaceId) => (permission) => checkPermission(user, account, permission, workspaceId);
const hasAnyPermission = (user, account, workspaceId) => (...permissions) => {
    return permissions.some((permission) => checkPermission(user, account, permission, workspaceId));
};
const hasAllPermissions = (user, account, workspaceId) => (...permissions) => {
    return permissions.every((permission) => checkPermission(user, account, permission, workspaceId));
};
export const PermissionsContext = createContext(null);
export function usePermissions() {
    return (useContext(PermissionsContext) ?? {
        hasPermission: () => false,
        hasAnyPermission: () => false,
        hasAllPermissions: () => false,
    });
}
export function PermissionsProvider({ user, account, workspaceId, children, }) {
    let value = {
        hasPermission: hasPermission(user, account, workspaceId),
        hasAnyPermission: hasAnyPermission(user, account, workspaceId),
        hasAllPermissions: hasAllPermissions(user, account, workspaceId),
    };
    return _jsx(PermissionsContext.Provider, { value: value, children: children });
}
//# sourceMappingURL=react.js.map